<h4 [class.small]="small">
  {{ title }}
  @if (soon) {
    <app-badge icon="/assets/icons/16/clock-filled.svg" color="orange">Soon</app-badge>
  }
  @if (scope) {
    <app-upgrade-badge
      [location]="location"
      [scope]="scope"
      [tenantId]="gallery?.['tenant']?.['id'] || gallery?.['tenant'] || state.activeTenant?.id"
    ></app-upgrade-badge>
  }
</h4>
<p class="standard-text" [class.small]="small">
  <ng-content></ng-content>
</p>
